import operation from '../action/operationActions'

export const initialState = ({
  isLoading: false,
  drivers: null,
  receivers: null,
})

export default function (state = initialState, action) {
  switch (action.type) {

    case operation.TYPES.REQUEST_DRIVERS:
      return Object.assign({}, state, {drivers: null, isLoading: true});

    case operation.TYPES.REQUEST_DRIVERS_SUCCESS:
      return Object.assign({}, state, {drivers: action.payload, isLoading: false})

    case operation.TYPES.REQUEST_DRIVERS_FAILED:
      return Object.assign({}, state, { drivers: null, isLoading: false })

    case operation.TYPES.UPDATE_DRIVERS_LIST:
      return Object.assign({}, state, { drivers: action.payload, isLoading: false })

    // Receiver **
    case operation.TYPES.REQUEST_CUSTOMERS:
      return Object.assign({}, state, {receivers: null, isLoading: true});

    case operation.TYPES.REQUEST_CUSTOMERS_SUCCESS:
      return Object.assign({}, state, {receivers: action.payload, isLoading: false})

    case operation.TYPES.REQUEST_CUSTOMERS_FAILED:
      return Object.assign({}, state, { receivers: null, isLoading: false })

    case operation.TYPES.UPDATE_CUSTOMERS_LIST:
      return Object.assign({}, state, { receivers: action.payload, isLoading: false })

    default:
      return state
  }
}
